:host {
  ::slotted([slot="primary"]),
  ::slotted([slot="secondary"]),
  ::slotted([slot="tertiary"]) {
    flex-grow: 1;
    margin: calc(#{space("medium")} / 2);
  }

  &[space-between="true"] ::slotted([slot="tertiary"]) {
    @include mq($from: small) {
      flex-grow: inherit;
    }
  }
}

.stzh-actions {
  &__actions {
    display: flex;
    flex-direction: column-reverse;
    margin: calc(#{space("medium")} / -2);

    @include mq($from: small) {
      flex-direction: row;
    }
  }

  &__primary-actions,
  &__secondary-actions,
  &__tertiary-actions {
    display: flex;
  }

  &__wrapper {
    display: contents;
  }

  // &--dialog &__actions {
  //   justify-content: flex-end;
  // }

  &--process &__wrapper {
    @include mq($to: small) {
      display: flex;
      flex-wrap: wrap;
    }
  }

  &--process &__actions {
    justify-content: flex-end;
  }

  &--process &__primary-actions,
  &--process &__secondary-actions {
    @include mq($to: small) {
      flex-grow: 1;
    }
  }

  &--process &__tertiary-actions {
    @include mq($from: small) {
      margin-right: auto;
    }
  }

  &--search &__actions {
    justify-content: flex-end;
  }

  /* space between */
  &--space-between &__actions {
    justify-content: space-between;

    @include mq($from: small) {
      flex-direction: column;
    }

    @include mq($from: medium) {
      flex-direction: row;
    }
  }

  &--space-between &__wrapper {
    @include mq($from: small) {
      display: flex;
      justify-content: flex-end;
    }
  }
}
